"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidHttpUrl = void 0;
// https://stackoverflow.com/a/43467144
function isValidHttpUrl(url) {
    let _url;
    try {
        _url = new URL(url);
    }
    catch (_) {
        return false;
    }
    return _url.protocol === "http:" || _url.protocol === "https:";
}
exports.isValidHttpUrl = isValidHttpUrl;
//# sourceMappingURL=isValidHttpUrl.js.map